import { User } from './user'

export interface BaseEvent {
  id?: number;
  name: string;
  startsAt: string;
}

/**
 * Event with expanded relationships
 */
export interface Event extends BaseEvent {
  assignees: User[];
}

export const emptyEvent = (): Event => ({
  name: '',
  startsAt: '',
  assignees: []
})

/**
 * Event with shallow relationships (IDs only)
 */
export interface ShallowEvent extends BaseEvent {
  assigneeIds: number[];
}

export const emptyShallowEvent = (): ShallowEvent => ({
  name: '',
  startsAt: '',
  assigneeIds: []
})
